import * as z from "zod";

/**
 * Admin RPC to trigger Recover 10DLC provisioning for a specific team.
 *
 * Ops manual path to retry failed provisionings and test teams. The
 * `requireExplicitConfirm` guard prevents accidental triggers (which
 * spend real money: ~$4 brand + up to $40 vetting + $10/month campaign).
 */
export const triggerRecoverProvisioning = {
  name: "triggerRecoverProvisioning" as const,
  input: z.object({
    teamId: z.string(),
    /**
     * Must be `true` for the RPC to actually start the workflow. The admin
     * UI modal flips this to true only after surfacing the cost breakdown
     * and a checkbox. Direct RPC callers must opt in explicitly.
     */
    requireExplicitConfirm: z.boolean(),
  }),
  output: z.discriminatedUnion("status", [
    z.object({ status: z.literal("started"), workflowId: z.string() }),
    z.object({ status: z.literal("already-running"), workflowId: z.string() }),
    z.object({ status: z.literal("completed"), phoneNumber: z.string() }),
    z.object({
      status: z.literal("blocked"),
      reason: z.enum([
        "missing-form-data",
        "missing-merchant-data",
        "bandwidth-unavailable",
        "country-unsupported",
        "confirmation-required",
        "provider-unavailable",
        "internal-error",
      ]),
      detail: z.string().optional(),
      missingFields: z.array(z.string()).optional(),
    }),
  ]),
};
